import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { UtilitiesService } from '../../services/utilities.service';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.scss'
})
export class PageNotFoundComponent {

  hasClientId = false;
  constructor(private router: Router, private utilities: UtilitiesService) {
    if (this.utilities.clientId) {
      this.hasClientId = true;
    }
  }

  redirectToSelectClientPage() {
    this.router.navigate(['select-client']);
  }
  redirectToDefaultPage() {
    this.utilities.redirectToDefaultURL();
  }
}
